import { baseApi } from "./api";
import type {
  DashboardStats,
  EnrollmentActivity,
  CategoryDistribution,
  TopCourses,
  ActivityStats,
} from "@nicsmith/shared_types";

export const adminStatsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get aggregated dashboard stats
    getDashboardStats: builder.query<DashboardStats, void>({
      query: () => "/admin/stats",
      providesTags: ["AdminStats"],
    }),

    // Get enrollment activity over time
    getEnrollmentActivity: builder.query<EnrollmentActivity, { period?: "day" | "week" | "month" }>({
      query: ({ period = "week" }) => ({
        url: "/admin/stats/enrollment-activity",
        params: { period },
      }),
      providesTags: ["AdminStats"],
    }),

    // Get category distribution
    getCategoryDistribution: builder.query<CategoryDistribution, { lang?: string } | void>({
      query: (args) => ({
        url: "/admin/stats/category-distribution",
        params: args ? { lang: args.lang } : {},
      }),
      providesTags: ["AdminStats"],
    }),

    // Get top courses
    getTopCourses: builder.query<TopCourses, { limit?: number; sortBy?: string; lang?: string }>({
      query: ({ limit = 5, sortBy = "enrolled_count", lang }) => ({
        url: "/admin/stats/top-courses",
        params: { limit, sortBy, ...(lang && { lang }) },
      }),
      providesTags: ["AdminStats"],
    }),

    // Get user activity stats
    getActivityStats: builder.query<ActivityStats, { period?: "day" | "week" | "month" }>({
      query: ({ period = "week" }) => ({
        url: "/admin/stats/activity-stats",
        params: { period },
      }),
      providesTags: ["AdminStats"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetDashboardStatsQuery,
  useGetEnrollmentActivityQuery,
  useGetCategoryDistributionQuery,
  useGetTopCoursesQuery,
  useGetActivityStatsQuery,
} = adminStatsApi;
